/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cloud_logic_custom": [
    {
      "name": "AdminQueries",
      "endpoint": "https://blqf30bw91.execute-api.us-east-1.amazonaws.com/final",
      "region": "us-east-1"
    }
  ],
  "aws_appsync_graphqlEndpoint": "https://zuorlthtmjhjjfhasfi3bbezcm.appsync-api.us-east-1.amazonaws.com/graphql",
  "aws_appsync_region": "us-east-1",
  "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
  "aws_cognito_identity_pool_id": "us-east-1:c9bf0c18-7fdf-482f-95eb-5d4f78e5d825",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_YipZ4gCjB",
  "aws_user_pools_web_client_id": "6cm898i2qdhkiucu5dic0r0idl",
  "oauth": {
    "domain": "cloudlicensing-test-final.auth.us-east-1.amazoncognito.com",
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "https://mr-ui-wip.d1yten4yb4z35f.amplifyapp.com/,http://localhost:8080/,https://www.analyticslicense.com/,https://dev-ui.analyticslicense.com/",
    "redirectSignOut": "https://mr-ui-wip.d1yten4yb4z35f.amplifyapp.com/,http://localhost:8080/,https://www.analyticslicense.com/,https://dev-ui.analyticslicense.com/",
    "responseType": "code"
  },
  "federationTarget": "COGNITO_USER_POOLS",
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [
    "GOOGLE"
  ],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [
    "SMS"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "usage-reports155718-final",
  "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
